import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRemovePhoto = ({ id } = {}) => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (userId) => {
      // Use userId parameter if provided, otherwise use id from options
      const targetId = userId || id;

      const result = await restClient({
        url: `${prefix}/profile/photo`,
        method: 'delete',
        data: targetId ? { key: targetId } : undefined
      });
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(['userData']);
    }
  });
};
